
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 36 36","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M24 7.5a4.501 4.501 0 00-4.13 2.711 8.586 8.586 0 015.342 5.427c.84-.161 1.546-.489 2.075-.926.739-.611 1.213-1.5 1.213-2.712A4.5 4.5 0 0024 7.5zm7.5 4.5c0 2.1-.869 3.838-2.301 5.023a6.706 6.706 0 01-.178.143A7.625 7.625 0 0133 23.867a7.632 7.632 0 01-7.632 7.632H9.75a6.75 6.75 0 01-2.029-13.19c.143-4.54 3.842-8.56 8.841-8.56h.281A7.5 7.5 0 0131.5 12zm-5.919 7.24a4.678 4.678 0 00-.674.02l-2.407.24a5.546 5.546 0 00-5.415-6.75h-.523c-3.153 0-5.522 2.421-5.812 5.25-.1.979.049 2.007.5 3h-1.5a3.75 3.75 0 000 7.5h15.618a4.632 4.632 0 00.213-9.26z","fill":"#0ABEC3"}})])
          )
        }
      }
    